export const ProtectSidebarId = "protect-sidebar";
export const ProtectSidebarBottomId = "protect-sidebar-bottom";

// Modules ideally register their own items without knowing about each other, but having priorities scattered
// across each module makes it hard to figure out the overall order. Centralizing them here makes that easier.
export const ProtectSidebarItemPriority = {
    Overview: 700,
    TenantInfo: 600,
    Recommendations: 550,
    Insights: 500,
    Reporting: 400,
    Policies: 300,
    Reviews: 200,
    ActivityLog: 100,
    Migrate: 50
} as const;

export const ProtectSidebarBottomItemPriority = {
    WorkspaceSettings: 100
} as const;
